import * as qiniu from 'qiniu-js'
import moment from 'moment'
import { message } from 'antd'
import appSetting from '../app/init/appsetting'
import CryptoJS from 'crypto-js'

const DEFAULT_IMG_PATH = 'default'

function buildQiniuKey(pathPrefix, file) {
  const prefix = (pathPrefix || DEFAULT_IMG_PATH).replace(/^\/+|\/+$/g, '')
  const name = (file && file.name ? file.name : 'file')
  const ext = name.includes('.') ? name.split('.').pop() : 'jpg'
  const uid = (file && file.uid) || String(Date.now())
  const dateDir = moment().format('YYYYMMDD')
  return `${prefix}/${dateDir}/${name.split('.')[0]}-${uid}.${ext}`
}

function resolveTokenFromResponse(res) {
  if (!res) return ''
  const d = res.data !== undefined ? res.data : res
  // 常见字段名: token / uptoken / data.token
  if (typeof d === 'string') return d
  if (d && typeof d === 'object') {
    if (d.token) return d.token
    if (d.uptoken) return d.uptoken
    if (d.data && (d.data.token || d.data.uptoken)) return d.data.token || d.data.uptoken
  }
  return ''
}

function base64UrlEncodeFromUtf8(input) {
  const utf8Bytes = unescape(encodeURIComponent(input))
  return btoa(utf8Bytes).replace(/\+/g, '-').replace(/\//g, '_')
}

// 无服务端情况下在前端生成上传凭证（存在安全风险，仅在内网/开发机使用）
function generateUploadTokenLocally() {
  const cfg = (appSetting && appSetting.qiniu) || {}
  const accessKey = cfg.accessKey
  const secretKey = cfg.secretKey
  const bucket = cfg.bucket
  const deadline = Math.floor(Date.now() / 1000) + (cfg.tokenExpireSeconds || 3600)
  if (!accessKey || !secretKey || !bucket) return ''

  const putPolicy = { scope: bucket, deadline }
  const putPolicyStr = JSON.stringify(putPolicy)
  const encodedPutPolicy = base64UrlEncodeFromUtf8(putPolicyStr)
  const sign = CryptoJS.HmacSHA1(encodedPutPolicy, secretKey)
  const signBase64 = CryptoJS.enc.Base64.stringify(sign)
  const encodedSign = signBase64.replace(/\+/g, '-').replace(/\//g, '_')
  return `${accessKey}:${encodedSign}:${encodedPutPolicy}`
}

export function UploadIMGToQiniu(file) {
  const originFile = file && file.originFileObj ? file.originFileObj : file
  const key = buildQiniuKey(DEFAULT_IMG_PATH, originFile)

  return new Promise((resolve, reject) => {
    const token = generateUploadTokenLocally()
    if (!token) {
      message.error('生成七牛上传凭证失败')
      reject(new Error('Failed to generate Qiniu token locally'))
      return
    }

    const putExtra = { fname: originFile.name, params: {}, mimeType: null }
    const config = { useCdnDomain: true, retryCount: 3 }
    const observable = qiniu.upload(originFile, key, token, putExtra, config)
    const subscription = observable.subscribe({
      next: () => {},
      error: (err) => {
        subscription && subscription.unsubscribe && subscription.unsubscribe()
        reject(err)
      },
      complete: (resp) => {
        const domain = (appSetting && appSetting.qiniu && appSetting.qiniu.bucketDomain) || ''
        if (!domain) {
          // 若未配置域名，直接返回 key，调用方可自行拼接
          resolve(resp && resp.key ? resp.key : key)
          return
        }
        const url = `${domain.replace(/\/$/, '')}/${(resp && resp.key) || key}`
        resolve(url)
      },
    })
  })
}

export default UploadIMGToQiniu

